/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

export type BasicErrorModel = {
  /**
   * The error code, will be `null` if the request was successful.
   */
  error_code?: string;
  /**
   * Details of the particular error, will be `null` if the request was successful.
   */
  error_details?: string;
  /**
   * Description of the error code, will be `null` if the request was successful.
   */
  error_string?: string;
  /**
   * The status of the response.
   */
  status?: BasicErrorModel.status;
};

export namespace BasicErrorModel {
  /**
   * The status of the response.
   */
  export enum status {
    SUCCESS = "SUCCESS",
    ERROR = "ERROR",
  }
}
